import {
	Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef,
	Input, AfterViewInit, EventEmitter, Output
} from '@angular/core';
import {
	trigger, state, style, transition, animate, query, stagger
} from '@angular/animations';
import { CustomerService } from '../../services/customer.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormControl } from '@angular/forms';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { PrintService } from '../../services/print.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';

@Component({
	selector: 'app-customer-no-purchase',
	templateUrl: './customer-no-purchase.component.html',
	styleUrls: ['./customer-no-purchase.component.scss'],
	animations: [
		trigger('flipState', [
			state('active', style({ transform: 'rotate3d(0, 1, 0, -179deg)' })),
			state('inactive', style({ transform: 'rotateY(0)' })),
			state('orderlookup', style({ transform: 'rotateY(-179deg)' })),
			transition('active <=> inactive', animate('500ms ease-in-out')),
			transition('inactive <=> orderlookup', animate('500ms ease-in-out')),
		]),
		trigger('openClose', [
			transition('false <=> true', animate(500))
		]),
		trigger('filterAnimation', [
			transition(':increment', [
				query(':enter', [
					style({ opacity: 0, width: 0 }),
					stagger(50, [animate('300ms ease-out', style({ opacity: 1, width: '*' }))])
				], { optional: true })
			]),
			transition(':decrement', [
				query(':leave', [
					stagger(50, [animate('300ms ease-out', style({ opacity: 0, width: 0 }))])
				])
			])
		]),
		trigger('grow', [
			transition(':enter', [
				style({ height: 0, width: 0 }),
				animate('200ms', style({ height: '*', width: '*', opacity: 1 }))
			]),
			transition(':leave', [
				animate('100ms', style({ height: 0, width: 0, opacity: 0 }))
			])
		])
	]
})
export class CustomerNoPurchaseComponent implements OnInit, AfterViewInit, OnDestroy {
	@Input() flip = 'inactive';
	
	@Input() dummydata = false;
	@Output() viewData = new EventEmitter<any>();
	@ViewChild('monthDetails') monthDetailsRef: ElementRef;
	@ViewChild('print_table') printtable: ElementRef;
	@ViewChild(MatPaginator) paginator: MatPaginator;
	@ViewChild(MatSort) sort: MatSort;

	dataSource: MatTableDataSource<any>;
	dataObs: Observable<any>;

	items_per_page = [25, 50, 100, 500];
	pagesizedefaultNop = 50;

	viewing: any = false;
	hideshowunits = new UntypedFormControl(true);
	hideshowsales = new UntypedFormControl(true);
	hideshowcost = new UntypedFormControl(false);
	defaultlocation = new UntypedFormControl('');
	data: any = false;
	sending = false;
	days = 60;
	daysmax = 365;
	title = `No Purchases ${this.days}/${this.daysmax} Days`;
	total = 0;
	brand_details: any = false;
	datasub: any = false;
	pageindex = 0;
	exporting = false;

	user: any = false;
	ref_location: any = false;
	filename = this.title;
	showFirstLastButtons = true;
	showPageSizeOptions = true;
	hidePageSize = false;

	constructor(
		private _changeDetectorRef: ChangeDetectorRef,
		private printService: PrintService,
		public globalSearchService: GlobalSearchService,
		private customerService: CustomerService,
		private modalService: NgbModal
	) {}

	ngOnInit(): void {
		this.setPagination([]);
		this.loadData();

		this.globalSearchService.user.subscribe(results => {
			if (this.user) {
				if (results.user.defaultlocation.loccode !== this.ref_location) {
					this.defaultlocation.setValue(this.user.user.defaultlocation.loccode);
					this.ref_location = false;
				}
			}

			this.user = results;
			if (!this.ref_location) {
				this.ref_location = this.user.user.defaultlocation.loccode;
			}
		});
	}

	ngAfterViewInit(): void {
		if (this.dataSource) {
			this.dataSource.paginator = this.paginator;
			this.dataSource.sort = this.sort;
			this.dataObs = this.dataSource.connect();
		}
	}

	loadDataOnly(data) {
		this.customerService.getNoPurchaseCustomers(data).subscribe((results: any) => {
			this.sending = false;
			this.data = results;
			this.setPagination(results);
		});
	}

	loadData() {
		const data = {
			numberofdays: this.days,
			daysmax: this.daysmax,
			pageindex: this.pageindex,
			pagesize: this.pagesizedefaultNop,
		};
		this.sending = true;
		this.datasub = this.customerService.getNoPurchaseCustomersCount(data).subscribe((r: any) => {
			if (r) {
				this.total = parseFloat(r.total); // always update total
			}
			
			this.loadDataOnly(data);
		});
	}

	getBrandSales(debtorno: any, brand: any) {
		const data = { debtorno, brands: [brand], from: 'all' };

		this.customerService.searchCustomerHistory(data).subscribe((results: any) => {
			this.sending = false;
			this.brand_details = results;
			this.modalService.open(this.monthDetailsRef, { ariaLabelledBy: 'modal-title', size: 'xl' });
		});
	}

	getCostTotalYear(year: any): number {
		return year.cost.reduce((acc: number, item: any) => acc + parseFloat(item.value), 0);
	}
	getSaleTotalYear(year: any): number {
		return year.sales.reduce((acc: number, item: any) => acc + parseFloat(item.value), 0);
	}
	getQtyTotalYear(year: any): number {
		return year.qty.reduce((acc: number, item: any) => acc + parseFloat(item.value), 0);
	}

	updateDays(event: any) {
		this.days = event.target.value;
	}
	updateDaysMax(event: any) {
		this.daysmax = event.target.value;
	}

	toggleFlip(data: any, title: string) {
		this.flip = data ? (this.flip === 'active' ? 'inactive' : 'active') : 'inactive';
		if (this.flip === 'active') {
			this.viewing = data;
			this.title = title;
			this.viewData.emit({ data, title: this.title , comp: 'nopurch' });
		} else {
			this.viewData.emit(false);
		}
	}

	exportPdf(html: string) {
		const encoded = this.globalSearchService.base64encode(html);
		const data = { content: encoded, filename: this.filename, landscape: true };
		this.printService.pdf(data).subscribe((result:any) => {
			this.globalSearchService.downloadPdf(result.content, data.filename);
		});
	}

	exportXls(html: string) {
		const encoded = this.globalSearchService.base64encode(html);
		const data = { content: encoded, filename: this.filename };
		this.printService.xls(data).subscribe((result:any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
		});
	}

	buildExportHtml(type: string) {
		if (!confirm('Warning: This report can take a long time to export.')) {return;}

		const data = {
			numberofdays: this.days,
			daysmax: this.daysmax,
			pageindex: 0,
			pagesize: this.total,
		};

		this.exporting = true;
		this.customerService.getNoPurchaseCustomers(data).subscribe((results: any) => {
			let html = `<table><thead><tr>
				<th style="text-align:left">Customer#</th>
				<th style="text-align:left">Name</th>
				<th style="text-align:left">Address1</th>
				<th style="text-align:left">City</th>
                                <th style="text-align:left">Region</th>
				<th style="text-align:left">Postal</th>
				<th style="text-align:left">SalesPerson</th>
				<th style="text-align:left">Last Seen</th>
				<th style="text-align:right">Total Spend</th>
				<th style="text-align:right">Avg Spend</th>
			</tr></thead><tbody>`;

			results.forEach(row => {
				html += `<tr>
					<td style="text-align:left">${row.debtorno}</td>
					<td style="text-align:left">${row.name}</td>
					<td style="text-align:left">${row.address1}</td>
					<td style="text-align:left">${row.address3}</td>
					<td style="text-align:left">${row.address4 || ''}</td>
					<td style="text-align:left">${row.address5}</td>
					<td style="text-align:left">${row.salesmanname?.name || ''}</td>
					<td style="text-align:left">${row.lastseen}</td>
					<td style="text-align:right">$${this.financial(+row.totalspend)}</td>
					<td style="text-align:right">$${this.financial(+row.avgspend)}</td>
				</tr>`;
			});

			html += '</tbody></table>';
			this.exporting = false;
			type === 'pdf' ? this.exportPdf(html) : this.exportXls(html);
		});
	}

	financial(num: number): number {
		return parseFloat((Math.round((num || 0) * 100) / 100).toFixed(2));
	}

	setPagination(tableData: any[]) {
		if (!this.dataSource) {
			this.dataSource = new MatTableDataSource<any>(tableData);
		} else {
			this.dataSource.data = tableData;
		}
	
		this._changeDetectorRef.detectChanges();
	
		if (this.paginator && this.sort) {
			this.dataSource.paginator = this.paginator;
			this.paginator.length = this.total;
			this.dataSource.sort = this.sort;
			this.dataObs = this.dataSource.connect();
		}
	}

	onPageChange(event: PageEvent) {
		this.pageindex = event.pageIndex;
		this.pagesizedefaultNop = event.pageSize;

		const data = {
			numberofdays: this.days,
			daysmax: this.daysmax,
			pageindex: this.pageindex,
			pagesize: this.pagesizedefaultNop,
		};

		this.loadDataOnly(data);
	}

	ngOnDestroy(): void {
		if (this.datasub) {
			this.datasub.unsubscribe();
		}
	}
}